export const configLang = {
  availableLangs: ['en', 'it', 'de', 'fr', 'nl', 'pl']
};
